import { useQuery } from '@apollo/client'
import { BackToTop } from '@cb/apricot-react'
import { GET_APP_PREFERENCES } from '@landscape/gql'
import {
  APContextDashboard,
  Modal,
  OverlaySpinner,
  appPreferencesState,
  useDashboardContext,
  apContextState,
} from '@landscape/ui-lib'
import { selectModalOptions, selectUser } from '@landscape/ui-redux'
import get from 'lodash/get'
import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useRecoilState, useRecoilValue } from 'recoil'
import { AggReport } from '../aggFile/AggReport'
import { StudentDashboard } from '../chart'
import { Help } from '../help'
import { HistoricalReport } from '../historicalFile/HistoricalReport'
import { Home } from '../home'
import { Jobs } from '../jobs'
import highschoolData from 'data/hs_list.json'

export const AppMain: React.FC = () => {
  const { rid } = useSelector(selectUser)
  const modalOptions = useSelector(selectModalOptions)
  const [appPreferences, setAppPreferences] = useRecoilState(appPreferencesState)
  const { data, loading, refetch } = useQuery(GET_APP_PREFERENCES, {
    fetchPolicy: 'cache-and-network',
  })
  const apContextFlag = useRecoilValue(apContextState)

  const dashboardReactContext = useDashboardContext()
  dashboardReactContext.refetchAppPreferences = refetch

  if (data && data.getAppPreferences) {
    let values = get(data, 'getAppPreferences.values') || {}
    if (
      values.disable_job_upload !== appPreferences.disable_job_upload ||
      values.disable_job_upload_msg !== appPreferences.disable_job_upload_msg ||
      values.disable_job_upload_title !== appPreferences.disable_job_upload_title ||
      values.service_maintenance_mode !== appPreferences.service_maintenance_mode
    ) {
      setAppPreferences({
        disable_job_upload: values.disable_job_upload,
        disable_job_upload_msg: values.disable_job_upload_msg,
        disable_job_upload_title: values.disable_job_upload_title,
        service_maintenance_mode: values.service_maintenance_mode,
      })
    }
  }

  const protectedRoutes = () => {
    if (rid === '810') {
      return (
        <>
          <Route exact path="/" component={Home} />
          <Route path="/jobs" component={Jobs} />
          <Route path="/chart/:applicantId" component={StudentDashboard} />
          <Route exact path="/chart" component={StudentDashboard} />
          {apContextFlag && (
            <Route
              exact
              path="/apchart"
              render={() => <APContextDashboard dataSource="graphql" hsData={highschoolData} />}
            />
          )}
          <Route exact path="/institution-reports" component={HistoricalReport} />
          <Route exact path="/agg-reports" component={AggReport} />
          <Route
            exact
            path="/v.php"
            render={(props) => {
              const searchStr = get(props, 'location.search') || ''
              const applicantId = searchStr.replace('?id=', '')
              const chartUrl = `/chart/${applicantId}`
              return <Redirect to={chartUrl} />
            }}
          />
          <Route exact path="/help" component={Help} />
        </>
      )
    }

    if (rid === '809') {
      return (
        <>
          <Route exact path="/" component={Home} />
          <Route path="/chart/:applicantId" component={StudentDashboard} />
          <Route exact path="/chart" component={StudentDashboard} />
          <Route exact path="/apchart" component={APContextDashboard} />
          <Route exact path="/help" component={Help} />
        </>
      )
    }

    return <></>
  }
  return (
    <>
      <OverlaySpinner show={loading} />
      {!loading && (
        <div className="container" id="top-of-content">
          <Switch>{protectedRoutes()}</Switch>
        </div>
      )}

      <Modal options={modalOptions} key="modal-container" />
      <BackToTop topOfPageAnchorId="top-of-content" />
    </>
  )
}
